import { IQueryParams } from '../../utils/location';
import { defaultRegionId, isValidRegion } from '../../utils/regions';
import { getRoomsFromString, IFilterQueryState, validRoomTypes } from './model';

export interface IFilterQueryParams extends IQueryParams {
  date: string | undefined;
  decoration: string | undefined;
  location: string | undefined;
  max_price: string | undefined;
  max_square: string | undefined;
  min_price: string | undefined;
  min_square: string | undefined;
  // Если выбрано несколько значений, они перечисляются через запятую
  // `rooms=studio,oneRoom,twoRoom,threeRoom,fourRoom` (студия, одна, две, три, четыре и более комнат.)
  rooms: string | undefined;
  hand_over: string | undefined;
}

function parseNumber(num: string | undefined) {
  return num ? Number(num) : undefined;
}

export function queryToFilter(query: IFilterQueryParams): IFilterQueryState {
  return {
    date: query.date !== undefined ? Number(query.date) : undefined,
    decoration: query.decoration === 'yes',
    handOver: query.hand_over === 'yes',
    price: {
      max: parseNumber(query.max_price),
      min: parseNumber(query.min_price),
    },
    region:
      query.location !== undefined && isValidRegion(query.location)
        ? query.location
        : Number(query.location) || defaultRegionId,
    rooms: query.rooms ? getRoomsFromString(query.rooms) : [],
    square: {
      max: parseNumber(query.max_square),
      min: parseNumber(query.min_square),
    },
  };
}

function stringifyBool(value: boolean) {
  return value ? 'yes' : 'no';
}

function stringifyOptional<T>(value: T) {
  return value ? String(value) : undefined;
}

function stringifyArr<T>(values: T[], valuesOrder: T[]) {
  const orderedValues = valuesOrder.filter(value => values.includes(value));

  return orderedValues.length ? orderedValues.join(',') : undefined;
}

export function filterToQuery(filter: IFilterQueryState): IFilterQueryParams {
  return {
    date: stringifyOptional(filter.date),
    decoration: filter.decoration ? stringifyBool(filter.decoration) : undefined,
    hand_over: filter.handOver ? stringifyBool(filter.handOver) : undefined,
    location: filter.region === 'moscow' ? undefined : String(filter.region),
    max_price: stringifyOptional(filter.price.max),
    max_square: stringifyOptional(filter.square.max),
    min_price: stringifyOptional(filter.price.min),
    min_square: stringifyOptional(filter.square.min),
    rooms: stringifyArr(filter.rooms, validRoomTypes),
  };
}
